import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    question: 'How fast can I get the loan?',
    answer: 'Our streamlined process enables approvals within 48-72 hours. Once approved, funds are disbursed directly to your account within 24 hours.'
  },
  {
    question: 'What documents are required?',
    answer: 'Basic requirements include business registration, last 2 years financial statements, 6 months bank statements, and KYC documents. Our team guides you through the entire process.'
  },
  {
    question: 'Is collateral mandatory?',
    answer: 'Not always. We offer both secured and unsecured loan options. Many of our products like MSME loans and merchant cash advances require no collateral.'
  },
  {
    question: 'What is the maximum loan amount?',
    answer: 'We offer loans ranging from ₹5 Lakhs up to ₹50 Crores depending on your business profile, creditworthiness, and the specific product chosen.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-2xl font-bold text-[#333333]">
            Frequently Asked <span className="text-[#5C1F33]">Questions</span>
          </h2>
        </motion.div>

        {/* FAQ List */}
        <div className="space-y-3 max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#5C1F33]/30 transition-colors bg-white"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="font-medium text-[#333333] text-sm pr-4">
                  {faq.question}
                </span>
                <motion.div
                  animate={{ rotate: openIndex === index ? 45 : 0 }}
                  transition={{ duration: 0.2 }}
                  className="w-6 h-6 bg-[#5C1F33]/10 rounded-full flex items-center justify-center flex-shrink-0"
                >
                  <span className="text-[#5C1F33] text-lg leading-none">+</span>
                </motion.div>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-4 pb-4 text-[#666666] text-sm leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;
